import { useSessionTimeout } from "@/hooks/useSessionTimeout";

export function SessionTimeoutGuard() {
  useSessionTimeout();
  return null;
}
